import * as microsoftTeams from '@microsoft/teams-js';
import React, { useEffect, useState } from 'react';
import { TeamsAuthContext } from './TeamsAuthContext';
import { TeamsLoginStartPath } from 'utils/routes';
import { checkInTeams } from 'utils/function';
import { getRequestConfigInTeams, msalInstance } from 'config/auth';

interface TeamsAuthContainerProps {
  children: JSX.Element;
}

const TeamsAuthContainer = ({ children }: TeamsAuthContainerProps) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  const [shouldLogin, setShouldLogin] = useState(false);

  useEffect(() => {
    const isInTeams = checkInTeams();
    if (!shouldLogin || !isInTeams) {
      setLoading(false);
      return;
    }

    (async () => {
      try {
        setLoading(true);

        await microsoftTeams.app.initialize();
        const context = await microsoftTeams.app.getContext();

        await microsoftTeams.authentication.authenticate({
          url: window.location.origin + TeamsLoginStartPath,
          height: 800,
        });
        microsoftTeams.app.notifySuccess();
        const request = getRequestConfigInTeams(context);
        await msalInstance.ssoSilent(request);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [shouldLogin]);

  if (loading) return <p>Authentication in progress.</p>;

  if (error) return <p>An Error Occurred: {JSON.stringify(error)}</p>;

  return (
    <TeamsAuthContext.Provider value={{ shouldLogin, setShouldLogin }}>
      {children}
    </TeamsAuthContext.Provider>
  );
};

export default TeamsAuthContainer;
